function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M173.165 51.804 C 54.316 73.326,8.189 220.950,93.620 306.380 C 173.115 385.876,309.667 352.559,343.516 245.409 C 377.419 138.087,283.861 31.759,173.165 51.804 M230.472 79.497 C 323.629 103.442,355.645 219.850,287.748 287.748 C 226.732 348.763,123.950 330.427,87.183 251.968 C 43.355 158.442,130.328 53.757,230.472 79.497 M149.411 150.007 L 140.156 159.317 160.473 179.659 L 180.789 200.000 160.463 220.351 L 140.138 240.701 149.718 250.282 L 159.299 259.862 179.649 239.537 L 200.000 219.211 220.351 239.537 L 240.701 259.862 250.282 250.282 L 259.862 240.701 239.537 220.351 L 219.211 200.000 239.537 179.649 L 259.862 159.299 250.282 149.718 L 240.701 140.138 220.351 160.463 L 200.000 180.789 179.930 160.743 C 168.891 149.718,159.591 140.698,159.263 140.698 C 158.935 140.698,154.502 144.887,149.411 150.007 ",
  stroke: "none",
  fillRule: "evenodd"
}));

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.3f4408f1.svg";
export { ForwardRef as ReactComponent };